module.exports = __webpack_public_path__ + "img/icomoon.664639f.svg";